import React from "react";
import { Modal, Button, Popup, Icon } from "semantic-ui-react";
import { dispatch } from "@rematch/core";
import popupImage from "../../../../../assets/images/popup_image.png";
import DefaultCategory from "../../../../drive/Categories/DefaultCategory";
import { toastr } from "react-redux-toastr";
class GeneratePlaybookModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playbookInput: {
        attributes: [
          {
            id: new Date().getTime(),
            key: "Role",
            value: "Business Analyst",
            isEdit: false,
            generationStarted: true,
            isComplete:true,
          },
        ],
      },
      oldAttr: null,
      topic: "",
      playbookName: "",
      // remainingCharCount:250,
      keyCharLimit:20,
      valueCharLimit:30,
      selectedCategories: [],
      buttonDisabled: false,
    };
  }
  async componentDidMount() {
    await dispatch.categories.getCategoryTreeByAccess({
      accountId: this.props.match.params.accountId,
      access: "Private",
    });
    if (this.state.topic === "" || this.state.selectedCategories.length < 3) {
      this.setState({ buttonDisabled: true });
    }
  }
  // componentDidUpdate(prevProps, prevState){
  //   if(this.state.topic === "" || this.state.selectedCategories.length < 3){
  //       this.setState({buttonDisabled : true})
  //   }
  // }
  setSelectedCategories = (categories) => {
    this.setState({ selectedCategories: categories });
    if (categories.length < 3 || this.state.topic.trim() === "") {
      this.setState({ buttonDisabled: true });
    } else {
      this.setState({ buttonDisabled: false });
    }
  };
  onChangeTopic = function (e) {
    this.setState({ topic: e.target.value }, () => {
    });
     
    if (
      e.target.value.trim() === "" ||
      this.state.selectedCategories.length < 3
    ) {
      this.setState({ buttonDisabled: true });
    } else {
      this.setState({ buttonDisabled: false });
    }
  };
  editArr = function (attr) {
    attr.isEdit = true;
    attr.isComplete = false;
    this.setState({ oldAttr: attr });
  };
  saveEditAttr = function (attr) {
    attr.isEdit = false;
    if(attr.key && attr.value && attr.key.length > 0 && attr.value.length > 0){
      attr.isComplete = true;
    }
    this.setState({ oldAttr: null });
  };
  valueChange = function (e, index) {
    // let value = e.target.value.slice(0, 30);
    let value = e.target.value;
    let attributes = this.state.playbookInput.attributes.map((attr, i) =>
      i === index ? { ...attr, value } : attr
    );
    this.setState((prevState) => ({
      playbookInput: {
        ...prevState.playbookInput,
        attributes,
      },
    }));
  };
  keyChange = function (e, index) {
    // let key = e.target.value.slice(0, 20);
    let key = e.target.value;
    let attributes = this.state.playbookInput.attributes.map((attr, i) =>
      i === index ? { ...attr, key } : attr
    );
    this.setState((prevState) => ({
      playbookInput: {
        ...prevState.playbookInput,
        attributes,
      },
    }));
  };
  createPlaybook = async () => {
    this.setState({buttonDisabled:true})
    const topicValue = this.state.topic.trim();
    const userRoleValue = this.state.playbookInput.attributes[0].value.trim();
    if (userRoleValue == "") {
      this.state.playbookInput.attributes[0].value = "Business Analyst";
    }
    if (topicValue !== "" && this.state.selectedCategories.length === 3) {
      let payload = {
        topic: topicValue,
        attributes: this.state.playbookInput.attributes.map((elem) => {
          return {
            key: elem.key,
            value: elem.value,
          };
        }),
        baseCategory: this.state.selectedCategories[0],
        category: this.state.selectedCategories[1],
        subCategory: this.state.selectedCategories[2],
      };
      payload.attributes.push({
        key: "topic",
        value: topicValue,
      })
      await dispatch.lifeCycle.getPlaybookName(payload);
      setTimeout(async () => {
      payload.name = this.props.generatedPlaybookName;
      this.setState({ generationStarted: true, playbookName:payload.name });
      await dispatch.lifeCycle.getPlaybookStructure(payload);
      let playbook = { ...this.props.playbook };
      dispatch.lifeCycle.setPlaybook(null);
      toastr.success("Message", "Your Response has been submitted");
      await dispatch.lifeCycle.setFilterByStatus(["-1"]);
      await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      dispatch.lifeCycle.setSelectedPracticeLibraryData({});
      let pathname = `/app/${playbook.accountId}/_ws/${playbook.organizationId}/_pb/status/Generating`;   
      this.props.history.push({ pathname: pathname });
      this.setState({ generationStarted: false, buttonDisabled:false });
      this.handleClose();
    }, 100);
    } else {
      this.setState({ generationStarted: false, buttonDisabled:false, playbookName:"" });
    }
    return;
  };
  cancelEditAttr = function (index) {
    let isCompleteOldAttr = this.state.oldAttr && this.state.oldAttr.key && this.state.oldAttr.value && this.state.oldAttr.key.length > 0 && this.state.oldAttr.value.length > 0
    let attributes = this.state.playbookInput.attributes.map((attr, i) =>
      i === index
        ? { ...this.state.oldAttr,isEdit:false, isComplete:isCompleteOldAttr }
        : attr
    );
    this.setState((prevState) => ({
      playbookInput: {
        ...prevState.playbookInput,
        attributes,
      },
    }));
    this.setState({ oldAttr: null });
  };
  addNewAttribute = function () {
  let attributes = this.state.playbookInput.attributes;
   if (attributes.length === 0 || attributes[attributes.length - 1].isComplete) {
    attributes.push({
      id: new Date().getTime(),
      key: "",
      value: "",
      isEdit: true,
      isComplete:false,
    });
    this.setState(
      (prevState) => ({
        playbookInput: {
          ...prevState.playbookInput,
          attributes,
        },
      }),
      () => {
        if (this.roleList) {
          this.roleList.scrollTop = this.roleList.scrollHeight;
        }
      }
    );
  }
};

  deleteArr = function (attrToDelete) {
    let attributes = this.state.playbookInput.attributes.filter(
      (attr) => attr.id !== attrToDelete.id
    );
    this.setState((prevState) => ({
      playbookInput: {
        ...prevState.playbookInput,
        attributes,
      },
    }));
  };
  handleClose = async (e) => {
    this.props.closeGeneratePlaybookModal(false);
    this.setState({
      playbookInput: {
        attributes: [
          {
            id: new Date().getTime(),
            key: "Role",
            value: "Business Analyst",
            isEdit: false,
            generationStarted: true,
          },
        ],
      },
      topic: "",
    });
  };
  render() {
    const { topic, generationStarted, buttonDisabled, playbookName } = this.state;
    let checkIsComplete = this.state.playbookInput.attributes.every(attr => attr.isComplete);
    // const {
    //   playbookGenerationIndex,
    //   playbookGenerationState,
    //   percentageGenerationComplete,
    //   playbook,
    // } = this.props;
    return (
      <Modal
        open={this.props.publishAllOpen}
        onClose={this.handleClose}
        size="large"
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >
        <Modal.Header> Compose a Playbook</Modal.Header>
        <p style={{ marginLeft: "20px", marginTop:"5px" }}>Create, customize, and share interactive playbooks</p>

        <Modal.Content style={{ maxHeight: "76vh", overflowY:"auto", display:"flex", flexDirection:"column",padding:"2px"}}>
          {/* {playbook === null ? (
            <div> */}
          {!generationStarted ? (
            <div className="generatePlaybookContainer">
              <div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <svg
                  style={{ width: "4rem", height: "4rem" }}
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 478.536 478.536"
                >
                  <path
                    style={{ fill: "#FCB641" }}
                    d="M403.628,172.368C403.628,81.592,330.036,8,239.26,8S74.892,81.592,74.892,172.368
            c0,46.16,19.088,89.696,49.736,119.552l16.352,74.616h196.216l16.352-74.312C384.388,262.352,403.628,218.696,403.628,172.368z"
                  />
                  <path
                    style={{ fill: "#4D4D4D" }}
                    d="M337.196,374.536H140.98c-3.76,0-7.008-2.616-7.816-6.288l-15.84-72.312
            C85.244,263.752,66.9,218.856,66.9,172.36C66.9,77.32,144.228,0,239.268,0s172.368,77.32,172.368,172.36
            c0,46.664-18.48,91.672-50.776,123.904l-15.84,71.992C344.204,371.92,340.948,374.536,337.196,374.536z M147.42,358.536h183.352
            l14.968-68.024c0.336-1.536,1.12-2.936,2.248-4.024c30.28-29.336,47.648-70.936,47.648-114.12
            c0-86.216-70.144-156.36-156.368-156.36S82.9,86.152,82.9,172.368c0,43.032,17.248,84.52,47.32,113.824
            c1.12,1.096,1.896,2.488,2.232,4.016L147.42,358.536z"
                  />
                  <polygon
                    style={{ fill: "#EB805B" }}
                    points="319.092,414.536 159.092,414.536 143.092,358.536 335.092,358.536 "
                  />
                  <path
                    style={{ fill: "#4D4D4D" }}
                    d="M319.092,422.536h-160c-3.568,0-6.712-2.368-7.688-5.8l-16-56c-0.688-2.416-0.208-5.008,1.304-7.016
            s3.872-3.184,6.384-3.184h192c2.512,0,4.872,1.176,6.384,3.184s2,4.6,1.304,7.016l-16,56
            C325.804,420.168,322.66,422.536,319.092,422.536z M165.124,406.536h147.928l11.432-40H153.7L165.124,406.536z"
                  />
                  <polygon
                    style={{ fill: "#E66032" }}
                    points="297.532,446.536 181.652,446.536 168.092,414.536 311.092,414.536 "
                  />
                  <g>
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M297.532,454.536h-115.88c-3.208,0-6.112-1.92-7.368-4.88l-13.56-32
              c-1.048-2.472-0.784-5.304,0.696-7.536c1.488-2.24,3.992-3.584,6.672-3.584h143c2.68,0,5.184,1.344,6.664,3.584
              c1.488,2.24,1.744,5.072,0.696,7.536l-13.56,32C303.644,452.616,300.748,454.536,297.532,454.536z M186.948,438.536h105.288
              l6.776-16h-118.84L186.948,438.536z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M192.444,349.016c-3.864,0-7.272-2.816-7.888-6.76l-34.728-220.96
              c-0.688-4.36,2.296-8.464,6.664-9.144c4.344-0.672,8.456,2.288,9.144,6.664l34.728,220.96c0.688,4.36-2.296,8.464-6.664,9.144
              C193.276,348.984,192.86,349.016,192.444,349.016z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M285.74,349.016c-0.416,0-0.832-0.032-1.256-0.096c-4.36-0.68-7.344-4.784-6.664-9.144
              l34.728-220.96c0.688-4.368,4.8-7.32,9.144-6.664c4.36,0.68,7.344,4.784,6.664,9.144l-34.728,220.96
              C293.012,346.2,289.604,349.016,285.74,349.016z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M279.068,156.536c-14.44,0-21.584-11.424-26.8-19.76c-5.32-8.512-8.176-12.24-13.224-12.24
              c-5.04,0-7.896,3.728-13.216,12.24c-5.208,8.336-12.344,19.76-26.784,19.76c-14.424,0-21.56-11.424-26.768-19.76
              c-5.312-8.504-8.168-12.24-13.192-12.24c-4.416,0-8-3.584-8-8s3.584-8,8-8c14.424,0,21.56,11.424,26.768,19.76
              c5.312,8.504,8.168,12.24,13.192,12.24c5.032,0,7.896-3.728,13.208-12.24c5.208-8.336,12.352-19.76,26.784-19.76
              c14.44,0,21.576,11.416,26.792,19.76c5.328,8.512,8.184,12.24,13.232,12.24s7.904-3.728,13.232-12.24
              c5.216-8.336,12.352-19.76,26.792-19.76c4.416,0,8,3.584,8,8s-3.584,8-8,8c-5.048,0-7.904,3.728-13.232,12.24
              C300.644,145.12,293.508,156.536,279.068,156.536z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M239.092,470.536c-4.416,0-8-3.584-8-8v-16c0-4.416,3.584-8,8-8s8,3.584,8,8v16
              C247.092,466.952,243.508,470.536,239.092,470.536z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M199.092,478.536c-4.416,0-8-3.584-8-8v-24c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8v24
              C207.092,474.952,203.508,478.536,199.092,478.536z"
                    />
                    <path
                      style={{ fill: "#4D4D4D" }}
                      d="M279.092,478.536c-4.416,0-8-3.584-8-8v-24c0-4.416,3.584-8,8-8s8,3.584,8,8v24
              C287.092,474.952,283.508,478.536,279.092,478.536z"
                    />
                  </g>
                  <path
                    style={{ fill: "#F2F2F2" }}
                    d="M311.092,70.536h-8c-4.416,0-8-3.584-8-8s3.584-8,8-8h8c4.416,0,8,3.584,8,8
            S315.508,70.536,311.092,70.536z"
                  />
                </svg>
              </div>
              <div className="custom-heading">
                What do you want to build today?
              </div>
              <p className="custom-paragraph">
                Using the Playbook Generator, you can turn any idea into a playbook. Simply enter your topic, add as much detail as you like, and let the AI build it for you.
              </p>

              <div className="custom-container">
                <div className="custom-input-container">
                  <textarea
                    type="text"
                    id="playbookTitle"
                    name="playbookTitle"
                    value={this.state.topic}
                    onChange={(e) => this.onChangeTopic(e)}
                    className="custom-input"
                    placeholder="Suggest Playbook Topic"
                    style={{
                      height:"15vh"
                    }}
                  />
                </div>
              </div>
              {/* <div style={{ fontSize: '12px',fontWeight:"bold",float:"right", color: "#666", marginRight:"40px", marginTop:"3px" }}>
                {this.state.remainingCharCount}/250
              </div> */}
              <div style={{fontWeight:"bold"}} className="suggestion-label">Suggestions
                <span style={{marginLeft:"4px"}}><Popup hoverable className="popupStyledWhite " wide='very' position='bottom right' trigger={
									<Icon style={{marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', width: '400px', whiteSpace:'normal', wordWrap:"break-word" }}>Suggestions are additional context you can provide when generating a Playbook.<br/>
                          When adding a suggestion you have a label and a value. The label is the name of the variable you are adding, and the value is the attribute being assigned to the variable.<br/>
                          For example you can define roles for the Playbook in the Suggestions. This can be done by entering "Role" as the label and the name of the specific role as the value e.g. "Business Analyst", "Human Resources".<br/><br/>
                          <div style={{ marginLeft: "12px",marginRight:"12px" }}>
                            <img src={popupImage} alt="Example" style={{ width: "100%" }} />
                          </div>
                        </div>}
								/></span>
              </div>
              <ul className="attribute-list">
                {this.state.playbookInput.attributes.map((attr, index) => (
                  <li
                    key={attr.id}
                    style={{
                      position: "relative",
                      display: "flex",
                      gap: "0.5rem",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "1.75rem",
                          bottom: 0,
                          left: "0.625rem",
                          width: "1px",
                          marginLeft: "-1px",
                          borderRight: "1px dashed #cbd5e0",
                          borderColor: "#cbd5e0",
                        }}
                      ></div>
                      {attr.isComplete && (
                        <svg
                          style={{
                            color: "rgb(22, 163, 74)",
                            width: "1.25rem",
                            height: "1.25rem",
                            marginTop: "0.6rem",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      )}
                      {!attr.isComplete && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            color: "rgb(225, 29, 72)",
                            width: "1.25rem",
                            height: "1.25rem",
                            marginTop: "0.6rem",
                          }}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                    <div
                      style={{
                        padding: "0.475rem 1.25rem",
                        borderRadius: "9999px",
                        fontSize: "0.75rem",
                        fontWeight: "500",
                        color: "#718096",
                        lineHeight: "1rem",
                        backgroundColor: "#f7fafc",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                        }}
                      >
                        {index === 0 && (
                          <div
                            style={{
                              fontWeight: "600",
                              color: "#2d3748",
                            }}
                          >
                            Role :{" "}
                          </div>
                        )}
                        {index !== 0 && (
                          <div><div style={{ color: "#2d3748" }}>
                            <input
                              disabled={!attr.isEdit}
                              class="input-attribute"
                              placeholder="New label"
                              style={{width:"200px"}}
                              value={attr.key}
                              onChange={(e) => this.keyChange(e, index)}
                            />
                          </div>
                          {/* <div style={{ fontSize: '8px',fontWeight:"bold",float:"right", color: "#666", marginTop:"1px" }}>
                          {attr.key ? 20-attr.key.length:20}/20
                        </div> */}
                        </div>
                        )}
                        {(attr.isEdit || attr.value !== null) && (
                          <div><div style={{ color: "#2d3748" }}>
                            <input
                              disabled={!attr.isEdit}
                              value={attr.value}
                              placeholder="New Value"
                              onChange={(e) => this.valueChange(e, index)}
                              class="input-attribute"
                            />
                          </div>
                          {/* <div style={{ fontSize: '8px',fontWeight:"bold",float:"right", color: "#666", marginTop:"1px" }}>
                          {attr.value ? 30-attr.value.length : 30}/30
                          </div> */}
                          </div>
                        )}

                        <div style={{ display: "flex", gap: "0.5rem" }}>
                          {!attr.isEdit && (
                            <span>
                              <svg
                                onClick={() => this.editArr(attr)}
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="editButton"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                />
                              </svg>
                              {index !== 0 && (
                                <svg
                                  onClick={() => this.deleteArr(attr)}
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="deleteButton"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                  />
                                </svg>
                              )}
                            </span>
                          )}
                        </div>
                        {attr.isEdit && (
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <svg
                              onClick={() => this.saveEditAttr(attr)}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="editButton"
                            >
                              <path
                                d="M17 9L9.99998 16L6.99994 13"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <svg
                              onClick={() => this.cancelEditAttr(index)}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="deleteButton"
                            >
                              <path
                                d="M16 8L8 16M8.00001 8L16 16"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
             <div className="add-attribute">
              {this.state.playbookInput.attributes.length === 0 ||
              this.state.playbookInput.attributes[this.state.playbookInput.attributes.length - 1].isComplete ? (
                <a
                  href="javascript:void(0)"
                  className="add-attribute"
                  style={{
                    color: "inherit",
                    marginLeft: "0.25rem",
                    marginRight: "0.25rem",
                  }}
                  onClick={() => {
                    this.addNewAttribute();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    style={{ width: "1rem", height: "1rem" }}
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                  <div>{"  "}New Suggestions</div>
                </a>
              ) : null}
            </div>
              <div style={{ paddingLeft: "40px", paddingRight: "40px", marginTop: "-10px" }}>
                <DefaultCategory
                  allCategories={this.props.categoryList}
                  handleCategorySelection={this.setSelectedCategories}
                  pageLevel="import"
                  selectedAccount={this.props.selectedAccount}
                />
              </div>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ marginTop: "15px", display: "flex" }}>
                <div style={{ margin: "auto", width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <h1
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        color: "#333",
                        wordWrap: "break-word",       
                        overflowWrap: "break-word",   
                        whiteSpace: "normal",         
                        maxWidth: "90%",              
                        margin: "0 auto",             
                        textAlign: "justify", 
                      }}
                    >
                      Generating Image For Topic - {playbookName}
                    </h1>
                  </div>
                  <div style={{ width: "100%" }}>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "60px", marginBottom: "60px" }}>
                <span class="generatingLoader"></span>
              </div>
            </div>
            
          )}
        </Modal.Content>
         <Modal.Actions>
         {!generationStarted ?<div>
                <div
                  className="custom-button-container"
                  style={{ display: "flex", justifyContent: "end", position:"sticky" }}
                >
                  <Button
                    id="cancelBtn"
                    style={{
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                      paddingTop: "0.7rem",
                      paddingBottom: "0.7rem",
                      marginRight: "1rem",
                    }}
                    className="button-cancel"
                    onClick={() => this.handleClose()}
                  >
                    Cancel
                  </Button>
                  <button
                    onClick={() => this.createPlaybook()}
                    class="custom-button"
                    style={{marginRight:"5px"}}
                    disabled={buttonDisabled || !checkIsComplete}
                  >
                    Start Building
                  </button>
                  <Popup hoverable className="popupStyledWhite " wide='very' position='bottom right' trigger={
									<Icon style={{marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', whiteSpace:'normal', wordWrap:"break-word" }}>Generate with AI</div>}
								/>
                </div></div>:<div></div>}
         </Modal.Actions> 
      </Modal>
    );
  }
}

export default GeneratePlaybookModal;
